/**
 * 파일명 : com0114p.jsx
 * 설명 : 직원보조부서선택
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 */


/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* AntD */
import { Layout, Row, Col, Space, Button, Table } from 'antd';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0114pAction } from '../../../redux/slice/com/com0114p_slice';
import { IDeptState } from '../../../redux/models/com/com0114p_model';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';


/************************************************
 * 전역변수 선언영억
 ************************************************/
const Com0114p = (props:any) => {
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch = useAppDispatch();
    const deptList = useAppSelector((state) => state.Com0114p.deptList);
    const selectedRowKeys = useAppSelector((state) => state.Com0114p.selectedRowKeys);


    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     **/
     React.useEffect(() => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc({deptStCd : 'A'}, {
            txCd: 'TRCOMR0005',
            success: (responseData:any) => {
                dispatch(Com0114pAction.setDeptList(responseData.deptItems));
            },
        });
    }, []);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnClose': {
                props.cancel();
                break;
            }
            case 'btnOk': {
                const datas = deptList.filter((item:IDeptState) => {
                    return selectedRowKeys.includes(item.deptCd);
                });
                props.accept(datas);
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
    const rowSelection = {
        onChange: (selectedRowKeys:any) => {
            dispatch(Com0114pAction.setSelectedRowKeys(selectedRowKeys));
        },
    };

    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
     /* Render 변수 선언영역 */
     /* AntD */
     const { Content } = Layout;

    /* Table Columns */
    const columns = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>부서코드</div>,
                dataIndex: 'deptCd',
                key: 'deptNm',
                align: 'center',
                width: 120,
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>부서명</div>,
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
                width: 200,
            }];
            return arr;
    }, []);

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Table
                    dataSource={deptList}
                    key='deptList'
                    rowKey='deptCd'
                    columns={columns()}
                    size='small'
                    style={{width:'500'}}
                    scroll={{x:150, y:300}}
                    pagination={false}
                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                />
                <Row justify='center' style={{ marginTop: 20 }}>
                    <Col>
                        <Space size='small'>
                        <Button
                            name='btnClose'
                            className='background-color-default-button'
                            onClick={onClick}
                        >
                            닫기
                        </Button>
                        <Button
                            name='btnOk'
                            className='background-color-primary-button'
                            onClick={onClick}
                        >
                            확인
                        </Button>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0114p;